import { render, staticRenderFns } from "./ChatJoinRequestsModal.vue?vue&type=template&id=4468e9b1"
import script from "./ChatJoinRequestsModal.vue?vue&type=script&lang=js"
export * from "./ChatJoinRequestsModal.vue?vue&type=script&lang=js"
import style0 from "./ChatJoinRequestsModal.vue?vue&type=style&index=0&id=4468e9b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports